import script from "./DocGroupBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./DocGroupBlock.vue?vue&type=script&setup=true&lang=js"

import "./DocGroupBlock.vue?vue&type=style&index=0&id=4f247346&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f247346"]])

export default __exports__